import React, { useEffect } from "react";
import { isAndroid, isIOS, isDesktop, isMacOs } from "react-device-detect";

const PrimaryBtn = ({ btnName }) => {
  useEffect(() => {
    if (isAndroid) {
      // console.log("user is in android:", isAndroid);
    } else if (isMacOs) {
      // console.log("user is in MAc:", isMacOs);
    } else if (isIOS) {
      // console.log("user is in IOS:", isIOS);
    } else {
      // console.log("user is in Desktop:", isDesktop);
    }
  }, []);

  const handleRedirect = () => {
    const playStore =
      "https://play.google.com/store/apps/details?id=com.webapps.tiffintap";

    const appStore = "https://apps.apple.com/us/app/tiffintap/id6754629728";

    let targetUrl = playStore;

    if (isAndroid) {
      targetUrl = playStore;
    } else if (isIOS) {
      targetUrl = appStore;
    }

    // 👉 Desktop → open in new tab
    if (isDesktop || isMacOs) {
      window.open(targetUrl, "_blank");
    }
    // 👉 Mobile → open in same tab (so store app opens)
    else {
      window.location.href = targetUrl;
    }
  };

  return (
    <button
      onClick={handleRedirect}
      className="px-8 py-3 rounded-xl bg-orange-500 text-white font-medium hover:bg-orange-600 transition"
    >
      {btnName}
    </button>
  );
};

export default PrimaryBtn;
